import { createUseStyles } from '@glu/theming';

const styles = (theme) => {
  const {
    palette: {
      grey,
      primary: { normal }
    },
    spacing: { unit }
  } = theme;
  return {
    linkLabel: {
      color: grey.A700,
      marginTop: '10px',
      padding: `${unit}px ${unit}px 0`
    },
    linkTitle: {
      color: normal,
      padding: `${unit}px`,
      textTransform: 'capitalize'
    },
    reactDropdown: {
      fontSize: 14,
      marginBottom: 0,
      '& label': {
        display: 'none'
      },
      '& [class^="wrapper"]': {
        width: 130
      },
      '&[data-qa="dropdown-payment_templates"]': {
        '& [class^="wrapper"]': {
          width: 160
        }
      },
      '& [data-qa="filter-text-input"]': {
        border: 'none',
        borderBottom: `1px solid ${grey.A700}`
      },
      '& [class^="wrapper"]>button': {
        border: `1px solid ${normal}`,
        fontFamily: 'Roboto Condensed, Roboto, ProximaNova, Helvetica, Arial, sans-serif',
        lineHeight: 'normal'
      },
      '& [class^="placeholder"]': {
        color: normal,
        textAlign: 'center',
        fontSize: `${unit * 1.75}px`
      },
      '& [class^="icon-caret-down"]': {
        fill: 'rgb(0, 112, 185)'
      },
      '& div[id*="dropdown-panel"]': {
        border: `1px solid ${normal}`,
        borderBottomRightRadius: 15,
        borderBottomLeftRadius: 15,
        color: grey,
        minWidth: '200px',
        width: '100%'
      },
      '& div[class^="panel"]': {
        boxShadow: 'none',
        zIndex: 101
      },
      '& div[class^="scroll"]': {
        maxHeight: 'none',
        overflowY: 'visible',
        borderBottomRightRadius: 15,
        borderBottomLeftRadius: 15
      }
    }
  };
};

export default createUseStyles(styles);
